import React from "react"
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription } from "src/components/ui/sheet"
import { LeadForm } from "./LeadForm"
import { useCreateLead, useUpdateLead } from "../hooks/useLeads"
import { useToast } from "src/components/ui/toast"

export function LeadDrawer({ open, onClose, lead, onSuccess }) {
  const isEdit = !!lead
  const { toast } = useToast()

  const createHook = useCreateLead()
  const updateHook = useUpdateLead()

  const isPending = createHook.isPending || updateHook.isPending

  async function handleSubmit(data) {
    // Strip empty strings before sending
    const payload = Object.fromEntries(
      Object.entries(data).filter(([, v]) => v !== "" && v !== null && v !== undefined)
    )

    // When editing, allow clearing the owner: send an explicit empty value so
    // the backend nils assigned_to_id (a stripped key would leave it unchanged).
    if (isEdit && (data.assigned_to_id === null || data.assigned_to_id === undefined)) {
      payload.assigned_to_id = ""
    }

    try {
      if (isEdit) {
        await updateHook.mutate(lead.id, payload)
        toast({ title: "Lead updated", description: lead.name })
      } else {
        await createHook.mutate(payload)
        toast({ title: "Lead created", description: payload.name })
      }
      onSuccess?.()
      onClose()
    } catch (errors) {
      const msg = Array.isArray(errors) ? errors[0] : (errors?.message || "Something went wrong")
      toast({ variant: "destructive", title: "Error", description: msg })
    }
  }

  return (
    <Sheet open={open} onOpenChange={(v) => !v && onClose()}>
      <SheetContent side="right" className="flex flex-col p-0 sm:max-w-[480px]">
        <SheetHeader>
          <SheetTitle>{isEdit ? "Edit Lead" : "New Lead"}</SheetTitle>
          <SheetDescription>
            {isEdit ? "Update the lead details below." : "Fill in the details to create a new lead."}
          </SheetDescription>
        </SheetHeader>

        <LeadForm
          lead={lead}
          onSubmit={handleSubmit}
          onCancel={onClose}
          isPending={isPending}
        />
      </SheetContent>
    </Sheet>
  )
}
